// import React from 'react';

// const ParagraphBlock = ({ block, onChange }) => {
//   return (
//     <div>
//       <textarea
//         placeholder="Write your paragraph here"
//         rows={4}
//         value={block.content}
//         onChange={(e) => onChange({ ...block, content: e.target.value })}
//       />
//     </div>
//   );
// };

// export default ParagraphBlock;

import React, { useState } from 'react';
import FormattingToolbar from './FormattingToolbar';

const ParagraphBlock = ({ block, onChange }) => {
  const [selectionStart, setSelectionStart] = useState(null);
  const [selectionEnd, setSelectionEnd] = useState(null);

  const applyFormat = (tag) => {
    if (selectionStart === null || selectionEnd === null || selectionStart === selectionEnd) return;

    const text = block.content;
    const before = text.substring(0, selectionStart);
    const selected = text.substring(selectionStart, selectionEnd);
    const after = text.substring(selectionEnd);
    const updated = `${before}<${tag}>${selected}</${tag}>${after}`;

    onChange({ ...block, content: updated });
  };

  return (
    <div>
      <FormattingToolbar onFormat={applyFormat} />
      <textarea
        placeholder="Write your paragraph here"
        rows={4}
        value={block.content}
        onChange={(e) => onChange({ ...block, content: e.target.value })}
        onSelect={(e) => {
          setSelectionStart(e.target.selectionStart);
          setSelectionEnd(e.target.selectionEnd);
        }}
        style={{ width: '100%', marginBottom: '8px' }}
      />
  </div>
  );
};

export default ParagraphBlock;
